import { render, staticRenderFns } from "./YwfzqkdjBrowse.vue?vue&type=template&id=1513f539"
import script from "./YwfzqkdjBrowse.vue?vue&type=script&lang=js"
export * from "./YwfzqkdjBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports